import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        bodyClass: 'menu-position-side menu-side-left dashboard',
        requireAuth: true
      },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
        },
        {
          path: '/empresa',
          name: 'Empresa',
          component: () => import(/* webpackChunkName: "empresaList" */ './views/empresa/Empresa.vue')
        },
        {
          path: '/empresa/form',
          name: 'EmpresaForm',
          component: () => import(/* webpackChunkName: "empresaForm" */ './views/empresa/EmpresaForm.vue')
        },
        {
          path: '/empresa/plano',
          name: 'EmpresaPlano',
          component: () => import(/* webpackChunkName: "empresaPlanoList" */ './views/empresa/Plano.vue')
        },
        {
          path: '/empresa/plano/split',
          name: 'SplitPlano',
          component: () => import(/* webpackChunkName: "splitPlano" */ './views/empresa/PlanoSplit.vue')
        },
        {
          path: '/empresa/plano/form',
          name: 'EmpresaPlanoForm',
          component: () => import(/* webpackChunkName: "empresaPlano" */ './views/empresa/PlanoForm.vue')
        },
        {
          path: '/empresa/vendedor',
          name: 'EmpresaVendedor',
          component: () => import(/* webpackChunkName: "empresaVendedor" */ './views/empresa/Vendedores.vue')
        },
        {
          path: '/empresa/vendedor/form',
          name: 'EmpresaVendedorForm',
          component: () => import(/* webpackChunkName: "empresa" */ './views/empresa/VendedoresForm.vue')
        },
        {
          path: '/empresa/afiliado',
          name: 'Afiliado',
          component: () => import(/* webpackChunkName: "afiliado" */ './views/empresa/Afiliado.vue')
        },
        {
          path: '/empresa/afiliado/form',
          name: 'AfiliadoForm',
          component: () => import(/* webpackChunkName: "afiliadoForm" */ './views/empresa/AfiliadoForm.vue')
        },
        {
          path: '/pedido',
          name: 'Pedido',
          component: () => import(/* webpackChunkName: "pedido" */ './views/pedido/Pedido.vue'),
          children: [
            {
              path: '',
              name: 'PedidoList',
              component: () => import(/* webpackChunkName: "pedidoList" */ './views/pedido/List.vue'),
            },
            {
              path: 'form',
              name: 'PedidoForm',
              component: () => import(/* webpackChunkName: "pedidoForm" */ './views/pedido/Form.vue'),
            }
          ]
        },
        {
          path: '/validarCartao',
          name: 'ValidarCartao',
          component: () => import(/* webpackChunkName: "validarCartao" */ './views/ValidarCartao.vue'),
        },
        {
          path: '/relatorio-pedidos',
          name: 'RelatorioPedidos',
          component: () => import(/* webpackChunkName: "relatorioPedido" */ './views/RelatorioPedido.vue'),
        },
        {
          path: '/pedidoDetail',
          name: 'PedidoDetail',
          component: () => import(/* webpackChunkName: "pedidoDetail" */ './views/PedidoDetail.vue'),
        },
        {
          path: '/transacoes',
          name: 'PedidoTransacoes',
          component: () => import(/* webpackChunkName: "peditoTransacoes" */ './views/Transacoes.vue'),
        },
        {
          name: 'PedidoTransacoesAvulsas',
          path: '/transacoes-avulsas',
          component: () => import(/* webpackChunkName: "peditoTransacoesAvulsas" */ './views/TransacoesAvulsa.vue')
        },
        {
          path: '/solicitacoes',
          name: 'GerenciarSolicitacoes',
          component: () => import(/* webpackChunkName: "solicitacoes" */ './views/Solicitacoes.vue'),
        },
        {
          path: '/financeiro',
          name: "Financeiro",
          component: () => import(/* webpackChunkName: "Financeiro" */ './views/Financeiro.vue'),
        },
        {
          path: "/detalhesEmpresas",
          name:"DetalhesEmpresas",
          component:() => import(/* webpackChunkName: "DetalhesEmpresas" */'./views/global/detalhesEmpresas.vue'),
        },
        {
          path: "/detalhesDrAchei",
          name:"DetalhesDrAchei",
          component:() => import(/* webpackChunkName: "DetalhesDrAchei" */'./views/global/detalhesDrAchei.vue'),
        },
        {
          path: "/detalhesClientes",
          name:"DetalhesClientes",
          component:() => import(/* webpackChunkName: "DetalhesClientes" */'./views/global/detalhesClientes.vue'),
        },
        {
          path: "/detalhesFaturas",
          name:"DetalhesFaturas",
          component:() => import(/* webpackChunkName: "DetalhesFaturas" */'./views/global/detalhesFaturas.vue'),
        },
        {
          path: "/detalhesFaturaAvulsa",
          name:"DetalhesFaturasAvulsa",
          component:() => import(/* webpackChunkName: "DetalhesFaturasAvulsa" */'./views/global/detalhesFaturaAvulsa.vue'),
        },
        {
          path: "/envioFaturas",
          name:"envioFaturas",
          component:() => import(/* webpackChunkName: "envioFaturas" */'./views/envioFaturas.vue'),
        },
        {
          path: "/transacoes-pagarme",
          name:"TransacoesPagarme",
          component:() => import(/* webpackChunkName: "transacoesPagarme" */'./views/TransacoesPagarme.vue'),
        },
        {
          path: '/parceiro',
          name: 'ParceiroList',
          component: () => import(/* webpackChunkName: "parceiroLlist" */'./views/parceiro/ParceiroList'),
        },
        {
          path: '/parceiro/form',
          name: 'ParceiroForm',
          component: () => import(/* webpackChunkName: "parceiroForm" */'./views/parceiro/ParceiroForm'),
        },
        {
          path: '/oferta',
          name: 'OfertaList',
          component: () => import(/* webpackChunkName: "ofertalist" */'./views/parceiro/OfertaList'),
        },
        {
          path: '/oferta/form',
          name: 'OfertaForm',
          component: () => import(/* webpackChunkName: "ofertaForm" */'./views/parceiro/OfertaForm'),
        },
        {
          path: '/beneficios',
          name: 'BeneficioList',
          component: () => import(/* webpackChunkName: "beneficioList" */'./views/beneficio/Beneficios'),
        },
        {
          path: '/beneficios/form',
          name: 'BeneficioForm',
          component: () => import(/* webpackChunkName: "beneficioForm" */'./views/beneficio/BeneficioForm'),
        }
      ]
    },
    {
      path: '/boas-vindas',
      name: 'BoasVindas',
      component: () => import(/* webpackChunkName: "boasVindas" */ './views/boasvindas/BoasVindas'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '*', redirect: 'Login'
    }
  ]
})
